import { createFileRoute } from "@tanstack/react-router";
import type { Walkthrough } from "gfx/walkthrough";
import usePlanSync from "lib/components/showroom2/data/usePlanSync";
import useShowroomConfig from "lib/components/showroom2/data/useShowroomConfig";
import useShowroomPlanData, { useShowroomBuilderData } from "lib/components/showroom2/data/useShowroomPlanData";
import ShowroomPhotorealDemo from "lib/components/showroom2/pages/ShowroomPhotorealDemo";
import { ShowroomProvider } from "lib/components/showroom2/state/useShowroomState";
import { useAppRouterParams } from "lib/routeHelpers";
import { useState } from "react";

function InteriorWalkthroughPage() {
  const { walkthroughId } = useAppRouterParams();
  const planData = useShowroomPlanData();
  const builderData = useShowroomBuilderData();
  useShowroomConfig(planData ?? undefined);
  usePlanSync();
  const [walkthrough, setWalkthrough] = useState<Walkthrough | undefined>(undefined);
  return (
    <ShowroomProvider key={walkthroughId}>
      <ShowroomPhotorealDemo
        planData={planData ?? undefined}
        builderData={builderData ?? undefined}
        walkthrough={walkthrough}
        setWalkthrough={setWalkthrough}
      />
    </ShowroomProvider>
  );
}

export const Route = createFileRoute("/demo/builders/$builder_name/walkthroughs/$walkthrough_id/")({
  component: InteriorWalkthroughPage,
  staticData: { isPublicPage: true },
});
